import { render } from "./Dermatology.vue?vue&type=template&id=2558ef19"
import script from "./Dermatology.vue?vue&type=script&lang=ts"
export * from "./Dermatology.vue?vue&type=script&lang=ts"
script.render = render

export default script